<template>
  <div class="card" style="margin-top:0;">
    <div class="card-header card-header-icon card-header-rose">
      <div class="card-icon">
        <i class="material-icons">notes</i>
      </div>
      <h3 class="card-title">SERVICIOS WELLBOAT MASIVO</h3>
    </div>
    <div class="card-body">
      <v-row class="mx-0">
        <v-col cols="2">
          <v-select prepend-icon="mdi-navigation" v-model="opcionReporte" :items="[
            { id: 1, nombre: 'Calendario' },
            { id: 2, nombre: 'Financiero' },
          ]" item-text="nombre" item-value="id" label="Tipo de Reporte" color="blue darken-3"
            @change="setCierre"></v-select>
        </v-col>
        <v-col cols="2" v-if="opcionReporte != 2">
          <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="inicio_formated" label="Fecha de Inicio" prepend-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="inicio" @input="menu1 = false" locale="es-cl" prev-icon="chevron_left"
              next-icon="chevron_right"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2" v-if="opcionReporte != 2">
          <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="termino_formated" label="Fecha de termino" prepend-icon="mdi-calendar" readonly
                v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="termino" @input="menu2 = false" locale="es-cl" prev-icon="chevron_left"
              next-icon="chevron_right"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="3" v-if="opcionReporte == 2">
          <v-select prepend-icon="mdi-navigation" v-model="cierre" :items="cierres" item-text="nombre" item-value="id"
            label="Elija periodo de cierre" color="blue darken-3"></v-select>
        </v-col>
        <v-col cols="2" class="pt-0 pt-6">
          <v-text-field
            v-model="filtroFolio"
            label="Buscar Folio"
            prepend-icon="mdi-magnify"
            clearable
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="2" class="pt-0 pt-6">
          <v-text-field
            v-model="filtroGuiaDespacho"
            label="Buscar Guia Desp."
            prepend-icon="mdi-magnify"
            clearable
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mx-0">
        <v-col cols="3">
          <v-autocomplete
            prepend-icon="mdi-ship-wheel"
            v-model="filtroWellboat"
            :items="wellboats"
            item-text="nombre"
            item-value="nombre"
            label="Filtro Wellboat"
            color="blue darken-3"
            clearable
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="3">
          <v-autocomplete
            prepend-icon="mdi-domain"
            v-model="filtroCliente"
            :items="empresas"
            item-text="razon_social"
            item-value="razon_social"
            label="Filtro Cliente"
            color="blue darken-3"
            clearable
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="3">
          <v-autocomplete
            prepend-icon="mdi-briefcase"
            v-model="filtroTipoTrabajo"
            :items="tipoPartesFiltrados"
            item-text="nombre"
            item-value="nombre"
            label="Tipo de Trabajo"
            color="blue darken-3"
            clearable
            dense
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="mx-0" justify="end">
        <v-col cols="auto" class="pt-0 pb-2">
          <v-btn class="mx-2" dark color="blue darken-1" @click="loadPartes"><i class="material-icons">cached</i>
            Generar</v-btn>
          <v-btn class="mx-2" dark @click="reporte_sw_nuevo_a_excel" v-if="can_download" color="green"><i
              class="material-icons">text_snippet</i> Excel</v-btn>
          <v-btn
            class="mx-2"
            dark
            color="purple darken-1"
            :loading="zipDownloading"
            :disabled="!exportSelectedIds.length"
            @click="downloadPDFsAsZip"
          >
            <i class="material-icons">archive</i>
            ZIP ({{ exportSelectedIds.length }})
          </v-btn>
        </v-col>
      </v-row>

      <div class="legend-guardado mb-2">
        <div class="legend-item">
          <i class="material-icons text-green">save</i>
          <span>Registro guardado</span>
        </div>

        <div class="legend-item">
          <i class="material-icons text-gray">save</i>
          <span>No guardado</span>
        </div>
      </div>


      <spinner v-if="spinner"></spinner>

      <v-data-table :headers="partesListHeaders" :items="partesListBodyFiltered" no-data-text="No hay partes" :search="search"
        :height="table_height" :header-props="{ sortIcon: 'arrow_upward' }" :hide-default-footer="true"
        disable-pagination>

        <template v-slot:header.export_check>
          <v-checkbox
            v-model="allExportSelected"
            hide-details
            dense
            color="white"
            style="color: white"
            :disabled="!exportableItems.length"
          ></v-checkbox>
        </template>

        <template v-slot:item="{ item }">
          <tr :class="`${item.select ? 'blue-grey lighten-4' : ''}`" :key="`${item.cargas_id}-${item.parte_descarga_id}`"
            v-on:dblclick="item.select = !item.select">
            <!-- Checkbox de exportación individual -->
            <td>
              <v-checkbox
                v-model="exportSelectedIds"
                :value="item.cargas_id"
                :disabled="!item.pdf"
                hide-details
                dense
              ></v-checkbox>
            </td>
            <!-- Acciones: guardar + descarga PDF individual -->
            <td class="td-col-1">
              <a @click="save(item)" v-if="permisos.grabar == 1" :title="item.sw_id"><i class="material-icons"
                  :class="item.guardado ? 'text-green' : 'text-gray'">save</i></a>
              <a @click="downloadPDF(item)" v-if="item.pdf"><i
                  class="material-icons text-red">picture_as_pdf</i></a>
            </td>
            <!-- N° Folio -->
            <td class="text-center">{{ item.folio }}</td>
            <!-- Fecha Viaje -->
            <td class="text-center">{{ item.fecha_viaje ? moment(item.fecha_viaje).format('DD-MM-YYYY') : '' }}</td>
            <!-- Wellboat -->
            <td class="text-center">{{ item.wellboat }}</td>
            <!-- Guia Despacho -->
            <td class="text-center">{{ item.guia_despacho }}</td>
            <!-- Cliente -->
            <td class="text-center">{{ item.empresa }}</td>
            <!-- Tipo de Trabajo -->
            <td class="text-center">{{ item.tipo_parte }}</td>
          </tr>
        </template>
      </v-data-table>


    </div>
    <!--
      <v-row>
          <v-col cols="8"></v-col>
          <v-col cols="4" class="text-right">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-2"
                  color="green darken-1"
                  dark
                  right
                  fab
                  small
                  @click="upload = !upload"
                  v-bind="attrs"
                  v-on="on"
                >
                  <i class="material-icons">upload</i>
                </v-btn>
              </template>
              <span>Subir excel histÃ³rico de Servicios Wellboat</span>
            </v-tooltip>
          </v-col>
        </v-row>
        -->
    <v-snackbar v-model="snackbar" :timeout="5000" :color="color">
      {{ validation_message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Modal upload -->
    <v-dialog v-model="upload" width="600px">
      <v-card>
        <v-card-title class="green darken-1">
          Subir listado de acopios desde excel
        </v-card-title>
        <v-card-text>
          <v-row class="mx-2">
            <v-file-input v-model="file" accept=".xls, .xlsx" label="Archivo Excel"></v-file-input>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="upload = false">Cancelar</v-btn>
          <v-btn color="primary" @click="uploadServiciosWellboat">Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal upload-->
    <!-- Modal Centro -->
    <v-dialog v-model="elegirCentro" width="600px">
      <v-card>
        <v-card-title class="green darken-1">
          Elija empresa y centro
        </v-card-title>
        <v-card-text>
          <v-row class="mx-2 my-2">
            <v-select v-model="empresa" :items="empresas" item-text="razon_social" item-value="id" label="Empresa"
              return-object @change="centros = empresa.centros">
            </v-select>
          </v-row>
          <v-row class="mx-2 my-2">
            <v-select v-model="centro" :items="centros" item-text="nombre" item-value="id" label="Centro" return-object>
            </v-select>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="elegirCentro = false">Cancelar</v-btn>
          <v-btn color="primary" @click="actualizarCentro">Actualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal Centro-->
  </div>
</template>
<style>
.text-green {
  color: #38b000;
}

.text-red {
  color: #dc2f02;
}

.text-gray {
  color: #3c3c3c;
}

.legend-guardado {
  display: flex;
  gap: 16px;
  align-items: center;
  font-size: 14px;
  background: #f8f9fa;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  width: fit-content;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.legend-item i {
  font-size: 20px;
}

.text-green {
  color: #38b000;
}

.text-gray {
  color: #3c3c3c;
}

.th-sticky {
  position: sticky;
  background: white;
  /* o el color del encabezado */
  z-index: 4;
  top: 0;
}

/* Columna 1 (mÃ¡s a la izquierda) */
.th-col-1 {
  left: 0;
  z-index: 5;
  /* mÃ¡s alto para que estÃ© por sobre otras sticky */
}

/* Columna 2 (la que sigue a la izquierda) */
.th-col-2 {
  left: 100px;
  /* ajusta al ancho real de la columna 1 */
  z-index: 5;
}

.td-col-1 {
  position: sticky;
  left: 0;
  z-index: 2;
  background: white;
  /* mayor para estar sobre col-2 */
}

.td-col-2 {
  position: sticky;
  left: 100px;
  z-index: 2;
  background: white;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  /* ajusta segÃºn el ancho de la primera columna */
}
</style>
<style scoped>
.table-wellboat {
  font-size: 16pt;
  margin-bottom: 20px;
  width: 100%;
  text-align: center;
}

.card {
  margin-top: 0;
}

.card .card-header-rose .card-icon {
  background: #263238;
  box-shadow: 0 4px 20px 0px rgba(0, 0, 0, 0.14),
    0 7px 10px -5px rgba(32, 30, 31, 0.822);
}

.mx-datepicker {
  width: 130px;
}
</style>
<script>
import { mapState, mapMutations } from "vuex";

export default {
  data: () => ({
    spinner: false,
    upload: false,
    file: null,
    opcionReporte: 1,
    opcionFiltro: 0,
    color: "green",
    snackbar: false,
    validation_message: "",
    search: null,
    isLoading: false,
    empresa: {},
    centro: {},
    centros: [],
    cierre: 0,
    cierres: [],
    plantas: [],
    inicio: "",
    termino: "",
    menu1: false,
    menu2: false,
    url_excel: "",
    url_pdf: "",
    table_height: 600,
    can_download: false,
    partesListHeaders: [
      // columna checkbox de exportacion
      {
        text: "",
        align: "center",
        value: "export_check",
        width: "50px",
        sortable: false,
        class: "blue-grey darken-4 white--text th-sticky th-col-1",
      },
      // columna acciones (guardar + PDF)
      {
        text: "Acciones",
        align: "center",
        value: "actions",
        width: "100px",
        sortable: false,
        class: "blue-grey darken-4 white--text th-sticky th-col-2",
      },
      {
        text: "N° Folio",
        align: "center",
        sortable: true,
        value: "folio",
        width: "110px",
        class: "blue-grey darken-4 white--text th-sticky",
      },
      {
        text: "Fecha Viaje",
        align: "center",
        sortable: true,
        value: "fecha_viaje",
        width: "150px",
        class: "blue-grey darken-4 white--text th-sticky",
      },
      {
        text: "Wellboat",
        align: "center",
        sortable: true,
        value: "wellboat",
        width: "150px",
        class: "blue-grey darken-4 white--text th-sticky",
      },
      {
        text: "Guia Desp.",
        align: "center",
        sortable: true,
        value: "guia_despacho",
        width: "150px",
        class: "blue-grey darken-4 white--text th-sticky",
      },
      /*necesito agregar cliente, tipo de trabajo y fecha viaje*/
      {
        text: "Cliente",
        align: "center",
        sortable: true,
        value: "empresa",
        width: "150px",
        class: "blue-grey darken-4 white--text th-sticky",
      },
      {
        text: "Tipo de Trabajo",
        align: "center",
        sortable: true,
        value: "tipo_parte",
        width: "150px",
        class: "blue-grey darken-4 white--text th-sticky",
      },
    ],
    partesListBody: [],
    permisos: {},
    especies: [],
    elegirCentro: false,
    item: {},
    muelles: [],
    campo: "carga",
    sortColumn: null,
    sortDirection: 'asc',
    // exportacion masiva ZIP
    filtroFolio: '',
    filtroGuiaDespacho: '',
    filtroWellboat: null,
    filtroCliente: null,
    filtroTipoTrabajo: null,
    exportSelectedIds: [],
    zipDownloading: false,
  }),
  mounted() {
    // Fetches defensivos: si el store está vacío (ej. rol Contable llega directo
    // a esta vista antes de que Login.vue termine sus dispatches async), cargar aquí.
    if (!this.$store.state.wellboats || !this.$store.state.wellboats.length) {
      this.$store.dispatch("getWellboats");
    }
    if (!this.$store.getters["empresa/getActive"].length) {
      this.$store.dispatch("empresa/fetchEmpresas");
    }
    if (!this.$store.getters["tipo_parte/getAll"].length) {
      this.$store.dispatch("tipo_parte/fetchTipoPartes");
    }
    this.acopios = this.$store.getters["acopio/getActive"];
    this.especies = this.$store.getters["especie/getActive"];
    this.muelles = this.$store.getters["muelle/getActive"];
    this.plantas = this.$store.getters["planta/getAll"];
    this.buscarPermisos();
    this.inicio = this.moment().format("YYYY-MM-01");
    this.termino = this.moment().format("YYYY-MM-DD");
    this.loadCierres();
    //this.loadPartes();
    if (window.innerHeight < 768) {
      this.table_height = 450;
    }
    if (window.innerHeight > 1080) {
      this.table_height = 900;
    }
  },
  methods: {

    onPesoInput(item) {
      if (typeof item.peso_planta_info_cliente === 'string') {
        item.peso_planta_info_cliente =
          item.peso_planta_info_cliente.replace(',', '.');
      }

      this.calcularTallaPezBlodNuevo(item);
      this.calcularTonCompensarPorNumeroPeces(item);
      this.calcularTonCompensar(item);
      this.calcularBiomasaTransportadaReal(item);
    },
    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortColumn = column
        this.sortDirection = 'asc'
      }
    },
    showModalCentro(item, campo) {
      this.elegirCentro = true;
      this.item = item;
      this.campo = campo;
    },
    actualizarCentro() {
      if (this.campo == "descarga") {
        this.item.centro_descarga = this.centro.nombre;
        this.item.destino_id = this.centro.id;
      }
      if (this.campo == "carga") {
        this.item.centro_carga = this.centro.nombre;
        this.item.origen_id = this.centro.id;
      }
      this.item.empresa = this.empresa.razon_social;
      this.item.empresas_id = this.empresa.id;
      // console.log('empresa',this.empresa,'centro',this.centro,'item',this.item)
      this.elegirCentro = false;
    },
    buscarPermisos() {
      if (this.user.menus == undefined) return {};
      let ruta = this.$router.currentRoute.name;
      this.user.menus.forEach((p) => {
        if (p.children != undefined) {
          p.children.forEach((ch) => {
            if (ch.path == ruta) {
              this.permisos = ch;
            }
          });
        }
        if (p.path == ruta) {
          this.permisos = p;
        }
      });
    },
    async loadCierres() {
      let url = `${this.base_url}cierres/lista/select`;
      await this.axios
        .get(url, this.headers_json)
        .then((response) => {
          this.cierres = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async loadPartes() {
      this.spinner = true;
      this.can_download = false;
      this.partesListBody = [];
      let url = `${this.base_url}cargas/bitacoras/reporte`;
      let data = {
        wellboats_id: this.user.wellboat.id,
        inicio: this.inicio,
        termino: this.termino,
        cierre: this.cierre,
        filtro: this.opcionFiltro,
        filtro_wellboat: this.filtroWellboat || null,
        filtro_cliente: this.filtroCliente || null,
        filtro_tipo_trabajo: this.filtroTipoTrabajo || null,
      };
      await this.axios
        .post(url, data, this.headers_json)
        .then((response) => {
          let partes = response.data.body;
          partes.forEach((parte) => {
            parte.fecha_viaje = this.moment(parte.fecha_viaje).toDate();
            parte.carga_eta = this.moment(parte.carga_eta).toDate();
            parte.carga_inicio = this.moment(parte.carga_inicio).toDate();
            parte.carga_termino = this.moment(parte.carga_termino).toDate();
            parte.traslado_inicio = this.moment(parte.traslado_inicio).toDate();
            parte.traslado_termino = this.moment(
              parte.traslado_termino
            ).toDate();
            parte.descarga_eta = this.moment(parte.descarga_eta).toDate();
            parte.descarga_inicio = this.moment(parte.descarga_inicio).toDate();
            parte.descarga_termino = this.moment(
              parte.descarga_termino
            ).toDate();
            parte.select = false;
          });
          this.partesListBody = partes;
          // Auto-seleccionar todos los items con PDF
          this.exportSelectedIds = this.partesListBody
            .filter(item => item.pdf)
            .map(item => item.cargas_id);
          //this.url_excel = this.storage_url + response.data.url_excel;
          this.url_excel = response.data.url;
          //this.url_pdf   = this.storage_url + response.data.url_pdf;
          this.showSnackBar(false);
          if (this.partesListBody.length > 0) this.can_download = true;
        })
        .catch((error) => {
          let response = error.response;
          //let msg = response.data.data;
          this.validation_message =
            response.status + ": " + response.data.message;
          this.showSnackBar(true);
          console.log(error);
        });
      this.spinner = false;
    },
    async reporte_sw_nuevo_a_excel() {
      const url = `${this.base_url}reporte_sw_masivo_a_excel`;
      const body = this.partesListBodyFiltered.map(item => ({
        folio:        item.folio,
        wellboat:     item.wellboat,
        guia_despacho: item.guia_despacho,
        empresa:      item.empresa,
        tipo_parte:   item.tipo_parte,
        fecha_viaje:  this.moment(item.fecha_viaje).format('YYYY-MM-DD HH:mm:ss'),
      }));
      await this.axios.post(url, body, this.headers_json).then(response => {
        this.url_excel = response.data;
        this.download();
      });
    },
    async save(item) {
      //console.log('fecha_viaje : ' + item.fecha_viaje);
      // let especie = item.la_especie;
      // if (typeof item.la_especie == 'object') {
      //   especie = item.la_especie.nombre;
      // }
      let url = `${this.base_url}cargas/bitacoras/reporte/grabar`;
      let data = {
        partes_id: item.partes_id,
        parte_descarga_id: item.parte_descarga_id,
        cargas_id: item.cargas_id,
        traslados_id: item.traslados_id,
        descargas_id: item.descargas_id,
        descargas_plantas_id: item.descargas_plantas_id,
        folio: item.folio,
        year: item.year,
        month: item.mes,
        fecha: this.moment(item.fecha_viaje).format("YYYY-MM-DD"),
        wellboat: item.wellboat,
        wellboats_id: item.wellboats_id,
        // empresa: item.parte.empresa.razon_social,
        // empresa: item.empresa ? item.empresa : item.parte.empresa.razon_social,
        empresa: item.empresa,
        empresas_id: item.empresas_id,
        //se setean solo si cambia el origen o destino
        origen_id: item.origen_id,
        destino_id: item.destino_id,
        tipo_destino: item.tipo_destino,
        //se setean solo si cambia el origen o destino

        guia: item.guia_despacho,
        centro: item.centro_carga,
        jaula_origen: item.jaulas_centro,

        acopio:
          item.centro_descarga instanceof Object
            ? item.centro_descarga.nombre
            : item.centro_descarga,
        acopios_id: item.centro_descarga.id,

        jaula_destino: item.jaulas_acopio,
        especie: item.especie,
        peces_guia: item.peces_guia,
        peces_contador: item.peces_contador,
        mort_viaje: item.peces_mort_viaje,
        mort_centro: item.peces_mort_centro,
        peces_planta: item.peces_planta,
        peces_total: item.peces_total,
        diferencia_conteo_numero: item.diferencia_conteo_numero,
        diferencia_conteo_porcentaje: item.diferencia_conteo_porcentaje,
        talla_pez_centro: item.talla_pez_centro,
        talla_pez_planta: item.talla_pez_planta,
        desviacion_maxima: item.desviacion_maxima,
        dif_planta_vs_desv_maxima: item.dif_planta_vs_desv_maxima,
        ton_compensar: item.ton_compensar,
        talla_pez_blod: item.talla_pez_blod,
        talla_total_planta: item.talla_total_planta,
        total_biomasa: item.total_carga_biomasa,
        densidad_carga: item.total_carga_densidad,
        observaciones: item.observaciones,
        carga_eta: this.moment(item.carga_eta).format("YYYY-MM-DD HH:mm:ss"),
        carga_inicio: this.moment(item.carga_inicio).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        carga_fin: this.moment(item.carga_termino).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        traslado_inicio: this.moment(item.traslado_inicio).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        traslado_fin: this.moment(item.traslado_termino).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        descarga_eta: this.moment(item.descarga_eta).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        descarga_inicio: this.moment(item.descarga_inicio).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        descarga_fin: this.moment(item.descarga_termino).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        carga_espera: item.carga_espera,
        carga_duracion: item.carga_duracion,
        traslado_espera: item.traslado_espera,
        traslado_duracion: item.traslado_duracion,
        descarga_espera: item.descarga_espera,
        descarga_duracion: item.descarga_duracion,
        total_horas: item.total,
        tecnico: item.tecnico_wellboat,
        peso_planta_info_cliente: item.peso_planta_info_cliente,
        ton_compensar_numero_peces: item.ton_compensar_numero_peces,
        /*ton_compensar_peso_planta_agua: item.ton_compensar_peso_planta_agua,*/
        biomasa_transportada_real: item.biomasa_transportada_real,
        total_carga_densidad_ajustada: item.total_carga_densidad_ajustada
      };
      //console.log("data", data);
      let response = null;
      try {
        response = await this.axios.post(url, data, this.headers_json);
        const index = this.partesListBody.findIndex(
          (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
        );
        this.$set(this.partesListBody[index], 'guardado', true);
        this.$set(this.partesListBody[index], 'sw_id', response.data.data.id);
        //console.log(response.data);

        //esto se comenta por precauciÃ³n, ya que se debe revisar en caso de que cambie el Error ATS (%) y Error COS -RTP(%) en acuerdos de contrato
        /*this.$set(this.partesListBody[index], 'desviacion_maxima', response.data.data.desviacion_maxima);
        this.$set(this.partesListBody[index], 'dif_planta_vs_desv_maxima', response.data.data.dif_planta_vs_desv_maxima);*/
        //console.log(response);
        this.showSnackBar(false);
        this.can_download = false;
      } catch (error) {
        response = error.response;
        let msg = response.data.data;
        this.validation_message =
          response.status + ": " + response.data.message + ". " + msg;
        this.showSnackBar(true);
      }
    },
    download() {
      window.open(this.url_excel);

      this.can_download = false;
    },
    downloadPDF(item) {
      let st_url = this.storage_url.replace("public", "docs");
      let pdf_url = st_url + item.pdf;
      //console.log(pdf_url);
      window.open(pdf_url);
    },
    async downloadPDFsAsZip() {
      const selected = this.partesListBody.filter(
        item => this.exportSelectedIds.includes(item.cargas_id) && item.pdf
      );
      if (!selected.length) return;

      const pdfs = selected.map(item => ({
        pdf: item.pdf,
        folio: item.folio,
        wellboat: item.wellboat,
        guia_despacho: item.guia_despacho,
      }));

      this.zipDownloading = true;
      try {
        const url = `${this.base_url}cargas/bitacoras/download-pdfs-zip`;
        const response = await this.axios.post(url, { pdfs }, {
          ...this.headers_json,
          responseType: 'blob',
        });
        const blob = new Blob([response.data], { type: 'application/zip' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `pdfs_wellboat_${this.moment().format('YYYYMMDD_HHmmss')}.zip`;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch {
        this.showSnackBar(true);
      } finally {
        this.zipDownloading = false;
      }
    },
    setCierre() {
      if (this.opcionReporte == 1) this.cierre = 0;
    },
    showSnackBar(error) {
      if (error) {
        this.color = "red";
      } else {
        this.color = "green";
        this.validation_message = "Ejecutado exitosamente!";
      }
      this.snackbar = true;
    },
    async uploadServiciosWellboat() {
      this.headers.headers["Content-Type"] = "multipart/form-data";
      let url = `${this.base_url}uploads/servicios_wellboat`;
      let formData = new FormData();
      formData.append("excel", this.file);
      let response = null;
      try {
        response = await this.axios.post(url, formData, this.headers);
        this.file = null;
        this.upload = false;
        this.showSnackBar(false);
      } catch (error) {
        response = error.response;
        let msg = response.data.data;
        this.validation_message =
          response.status + ": " + response.data.message + ". " + msg;
        this.showSnackBar(true);
      }
    },
    ...mapMutations(["actualizarBaseUrl", "mostrarLoading", "ocultarLoading"]),
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    reformatDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    calcularPecesTotalViaje(item) {
      // const index = this.partesListBody.findIndex(p => p.id == item.id);
      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );
      let total =
        parseInt(item.peces_mort_viaje) +
        parseInt(item.peces_mort_centro) +
        parseInt(item.peces_planta);
      item.peces_total = total;
      this.$set(this.partesListBody, index, item);
      this.calcularDiferenciaConteo(item);
      this.calcularDiferenciaPlantaVSDesviacionMaxima(item, index)
      this.calcularTonCompensarPorNumeroPeces(item)
      this.calcularBiomasaTransportadaReal(item, index)
      this.calcularToneladasCompensar(item);
    },

    //nuevo SW 2026
    calcularBiomasaTransportadaReal(item, index) {
      let valor = this.calculoBiomasaTransportadaReal(item)
      item.biomasa_transportada_real = valor
      this.$set(this.partesListBody, index, item);
      this.calcularTotalCargaDensidadAjustada(item)
    },

    //nuevo sw 2026
    calculoBiomasaTransportadaReal(item) {
      let valor = item.peces_planta * this.calculoPesoRealAgua(item.peso_planta_info_cliente)
      return valor
    },

    /*calcularToneladasCompensar(item) {
      //this.calcularDesviacionPlantaMaxima(item);
      // const index = this.partesListBody.findIndex(p => p.id == item.id);
      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );
      let pdm = item.dif_planta_vs_desv_maxima;
      let tpps = `${item.talla_pez_planta}`;
      if (
        typeof item.talla_pez_planta == "string" &&
        item.talla_pez_planta.indexOf(",")
      ) {
        tpps = item.talla_pez_planta.replace(",", ".");
      }
      let tpp = parseFloat(tpps);
      let tons = (parseFloat(pdm) * parseFloat(tpp)) / 1000;
      item.ton_compensar = tons.toFixed(2) >= 0 ? tons.toFixed(2) : 0;
      this.$set(this.partesListBody, index, item);
      //this.calcularTallaPezBlod(item);
    },*/
    calcularDiferenciaConteo(item) {
      // const index = this.partesListBody.findIndex(p => p.id == item.id);
      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );
      //let dif = parseInt(item.peces_total) - parseInt(item.peces_contador);
      //nuevo sw 2026
      let dif = parseInt(item.peces_planta) - parseInt(item.peces_contador);
      item.diferencia_conteo_numero = Math.round(dif);
      /*let dif_porc = (dif / item.peces_contador) * 100;
      item.diferencia_conteo_porcentaje = dif_porc.toFixed(2);*/
      this.$set(this.partesListBody, index, item);
      this.calcularDiferenciaConteoPorcentaje(index, item)
      this.calcularErrorConteoMaximo(index, item)
    },

    //nuevo sw 2026
    calcularDiferenciaConteoPorcentaje(index, item) {
      let valor = -100; // valor por defecto

      if (item.peces_planta != 0 && item.peces_planta != "") {
        valor = (item.peces_planta - item.peces_contador) / item.peces_planta;
      }
      item.diferencia_conteo_porcentaje = valor.toFixed(2);
      this.$set(this.partesListBody, index, item);
    },

    //nuevo sw 2026
    calcularErrorConteoMaximo(index, item) {
      let valor = item.peces_contador * item.factor
      item.desviacion_maxima = valor.toFixed(0)
      this.$set(this.partesListBody, index, item)
    },

    //nuevo sw 2026
    calcularDiferenciaPlantaVSDesviacionMaxima(item, index) {

      const dif_planta_vs_desv_maxima = this.calculoDiferenciaPlantaVSDesviacionMaxima(item)
      item.dif_planta_vs_desv_maxima = dif_planta_vs_desv_maxima.toFixed(2)
      this.$set(this.partesListBody, index, item)
    },

    //nuevo 2026
    calculoDiferenciaPlantaVSDesviacionMaxima(item) {

      const diff = item.peces_planta - item.peces_contador;

      const signo = diff > 0 ? 1 : (diff < 0 ? -1 : 0);

      const dif_planta_vs_desv_maxima =
        signo * (Math.abs(diff) - (item.peces_contador * item.factor));
      return dif_planta_vs_desv_maxima
    },

    calcularTotalCargaBiomasa(item) {
      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );
      let valor = this.calculoTotalCargaBiomasa(item)
      item.total_carga_biomasa = valor.toFixed(0)
      this.$set(this.partesListBody, index, item)
    },

    calculoTotalCargaBiomasa(item) {
      const valor = item.peces_contador * item.talla_pez_centro
      return valor
    },

    //en deshuso
    /*calcularDesviacionMaxima(item) {
      // const index = this.partesListBody.findIndex(p => p.id == item.id);
      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );
      let dvm = item.peces * 0.95;
      item.desviacion_maxima = Math.round(dvm);
      this.$set(this.partesListBody, index, item);
    },*/
    /*calcularDesviacionPlantaMaxima(item) {
      // const index = this.partesListBody.findIndex(p => p.id == item.id);
      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );
      let dm = parseFloat(item.desviacion_maxima);
      let pt = parseFloat(item.peces_total);
      let dvmp = dm - pt;
      item.dif_planta_vs_desv_maxima = dvmp.toFixed(2);
      this.$set(this.partesListBody, index, item);
    },*/
    /*calcularTallaPezBlod(item) {
      // const index = this.partesListBody.findIndex(p => p.id == item.id);
      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );
      let tpps = `${item.talla_pez_planta}`;
      if (
        typeof item.talla_pez_planta == "string" &&
        item.talla_pez_planta.indexOf(",")
      ) {
        tpps = item.talla_pez_planta.replace(",", ".");
      }
      let tpc = parseFloat(item.talla_pez_centro);
      let tpp = parseFloat(tpps);
      let tpb = ((tpc - tpp) / tpc) * 100;
      item.talla_pez_blod = tpb.toFixed(3);
      this.$set(this.partesListBody, index, item);
      this.calcularTallaPezPlanta(item);
    },*/

    //nuevo sw 2026
    /*calcularTallaPezBlodNuevo(item) {
      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );
      let valor = (item.talla_pez_centro - item.peso_planta_info_cliente) / item.peso_planta_info_cliente
      item.talla_pez_blod = valor.toFixed(3)
      this.$set(this.partesListBody, index, item);
      this.calcularPesoRealAgua(item)
    },*/
    //nuevo sw 2026
    calcularTallaPezBlodNuevo(item) {
      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );

      const peso = Number(item.peso_planta_info_cliente);
      const tallaCentro = Number(item.talla_pez_centro);

      let valor = 0;

      if (peso && peso !== 0) {
        valor = (tallaCentro - peso) / peso;
      } else {
        valor = 0; // o el valor por defecto que necesites
      }

      item.talla_pez_blod = Number(valor.toFixed(3));

      this.$set(this.partesListBody, index, item);
      this.calcularPesoRealAgua(item);
    },
    /*calcularTallaPezPlanta(item) {
      // const index = this.partesListBody.findIndex(p => p.id == item.id);
      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );
      let tpc = item.talla_pez_centro;
      let tpb = item.talla_pez_blod;
      let tpp = parseFloat(tpc) + (parseFloat(tpc) * parseFloat(tpb)) / 100;
      item.talla_total_planta = tpp.toFixed(3);
      this.$set(this.partesListBody, index, item);
    },*/

    //nuevo SW 2026
    calcularPesoRealAgua(item) {
      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );

      let valor = this.calculoPesoRealAgua(item.peso_planta_info_cliente)
      item.talla_total_planta = valor.toFixed(3);
      //console.log('valor peso real agua', valor)

      this.$set(this.partesListBody, index, item);
      //this.calcularTonCompensarPorPesoPlantaAgua(item)
    },

    calculoPesoRealAgua(peso_planta_info_cliente) {
      return Number(peso_planta_info_cliente) + (Number(peso_planta_info_cliente) * 0.07)
    },

    //nuevo SW 2026
    calcularTotalCargaDensidadAjustada(item) {
      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );
      let valor = this.calculoBiomasaTransportadaReal(item) / 1000
      item.total_carga_densidad_ajustada = valor.toFixed(2)
      this.$set(this.partesListBody, index, item);
    },

    //nuevo SW 2026
    calcularTonCompensarPorNumeroPeces(item) {

      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );

      let valor = this.calculoTonCompensarPorNumeroPeces(item)

      item.ton_compensar_numero_peces = valor.toFixed(1);
      this.$set(this.partesListBody, index, item);
    },

    //nuevo SW 2026
    calculoTonCompensarPorNumeroPeces(item) {
      const A = Number(this.calculoDiferenciaPlantaVSDesviacionMaxima(item));
      const B = Number(this.calculoPesoRealAgua(item.peso_planta_info_cliente));

      return (A * B) / 1000;
    },

    //nuevo SW 2026
    calculoTonCompensarPorPesoPlantaAgua(item) {
      const A = item.peces_planta;
      const B = item.peso_planta_info_cliente;
      const C = item.talla_total_planta;

      // ValidaciÃ³n equivalente al SI(O(...);0)
      if (!A || A === 0 || !B || B === 0 || !C || C === 0) {
        return 0;
      } else {
        // (W7*S7 - AE7*S7) / 1000
        return ((B * A) - (C * A)) / 1000;
      }


    },

    /*calcularTonCompensarPorPesoPlantaAgua(item) {
      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );
      let valor = this.calculoTonCompensarPorPesoPlantaAgua(item)
      item.ton_compensar_peso_planta_agua = valor.toFixed(2)
      //console.log(item)
      this.$set(this.partesListBody, index, item)
    },*/

    //nuevo SW 2026 (ton a Compensar Biomasa)
    calcularTonCompensar(item) {
      const index = this.partesListBody.findIndex(
        (p) => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id
      );
      const total_carga_biomasa = this.calculoTotalCargaBiomasa(item)
      const biomasa_transportada_real = this.calculoBiomasaTransportadaReal(item)
      const ton_compensar_biomasa = (biomasa_transportada_real - total_carga_biomasa) / 1000

      item.ton_compensar = ton_compensar_biomasa.toFixed(2)
      this.$set(this.partesListBody, index, item);
    },

    calcularTiempoCarga(item) {
      /* item.carga_espera = this.restarHoras(item.carga_eta, item.carga_inicio);
      item.carga_duracion = this.restarHoras(
        item.carga_inicio,
        item.carga_termino
      ); */
      this.calcularTiempoTotal(item);
    },
    calcularTiempoTraslado(item) {
      /* item.traslado_espera = this.restarHoras(
        item.carga_termino,
        item.traslado_inicio
      );
      item.traslado_duracion = this.restarHoras(
        item.traslado_inicio,
        item.traslado_termino
      ); */
      this.calcularTiempoTotal(item)
    },
    calcularTiempoDescarga(item) {
      /* item.descarga_espera = this.restarHoras(
        item.descarga_eta,
        item.descarga_inicio
      );
      item.descarga_duracion = this.restarHoras(
        item.descarga_inicio,
        item.descarga_termino
      ); */
      this.calcularTiempoTotal(item);
    },

    async calcularTiempoTotal(item) {
      let body = {
        carga_eta: this.moment(item.carga_eta).format('YYYY-MM-DD HH:mm:ss'),
        carga_inicio: this.moment(item.carga_inicio).format('YYYY-MM-DD HH:mm:ss'),
        carga_termino: this.moment(item.carga_termino).format('YYYY-MM-DD HH:mm:ss'),
        traslado_inicio: this.moment(item.traslado_inicio).format('YYYY-MM-DD HH:mm:ss'),
        traslado_termino: this.moment(item.traslado_termino).format('YYYY-MM-DD HH:mm:ss'),
        descarga_eta: this.moment(item.descarga_eta).format('YYYY-MM-DD HH:mm:ss'),
        descarga_inicio: this.moment(item.descarga_inicio).format('YYYY-MM-DD HH:mm:ss'),
        descarga_termino: this.moment(item.descarga_termino).format('YYYY-MM-DD HH:mm:ss'),
        tiempo_carga_contrato: item.tiempo_carga_contrato
      }
      await this.axios.post(`${this.base_url}cargas/calculo/total_horas`, body, this.headers_json).then(r => {

        let idx = this.partesListBody.findIndex(p => p.cargas_id == item.cargas_id && p.parte_descarga_id == item.parte_descarga_id)
        this.$set(this.partesListBody[idx], 'total', r.data.total_horas)
        this.$set(this.partesListBody[idx], 'carga_espera', r.data.tiempo_espera_carga)
        this.$set(this.partesListBody[idx], 'carga_duracion', r.data.tiempo_carga)
        this.$set(this.partesListBody[idx], 'traslado_espera', r.data.tiempo_espera_traslado)
        this.$set(this.partesListBody[idx], 'traslado_duracion', r.data.tiempo_traslado)
        this.$set(this.partesListBody[idx], 'descarga_espera', r.data.tiempo_espera_descarga)
        this.$set(this.partesListBody[idx], 'descarga_duracion', r.data.tiempo_descarga)
        //console.log('res',r)
      })
    },
    calcularTiempoTotalOld(item) {
      let sumar = parseInt(this.moment("1970-01-01").format("x"));
      let espera_carga = this.restarHoras(
        item.carga_eta,
        item.carga_inicio,
        true
      );
      let duracion_carga = this.restarHoras(
        item.carga_inicio,
        item.carga_termino,
        true
      );
      let espera_descarga = this.restarHoras(
        item.descarga_eta,
        item.descarga_inicio,
        true
      );
      let duracion_descarga = this.restarHoras(
        item.descarga_inicio,
        item.descarga_termino,
        true
      );

      let total =
        espera_carga +
        duracion_carga +
        espera_descarga +
        duracion_descarga +
        sumar;
      let maximo = parseInt(
        this.moment("1970-01-01 " + this.user.wellboat.tiempo_carga).format("x")
      );
      if (total > maximo) {
        let termino = this.moment(total).format("YYYY-MM-DD HH:mm:ss");
        let inicio = this.moment(maximo).format("YYYY-MM-DD HH:mm:ss");
        item.total = this.restarHoras(inicio, termino);
        return;
      }
      item.total = "00:00:00";
    },
    restarHoras(hora_inicio, hora_termino, millis = false) {
      let sumar = parseInt(this.moment("1970-01-01").format("x"));
      let inicio = this.moment(hora_inicio);
      let termino = this.moment(hora_termino);
      let diff = termino.diff(inicio) + sumar;
      if (millis) return termino.diff(inicio);
      let dias = parseInt(this.moment(diff).format("D")) - 1;
      let horas = parseInt(this.moment(diff).format("H"));
      if (dias > 0) horas += 24 * dias;
      return (
        horas.toString().padStart(2, "0") + this.moment(diff).format(":mm:ss")
      );
    },
    formatNumber(numero, decimales = 2, campo = null) {
      //, checknegative = false){
      if (campo != null) console.log(numero);
      if (isNaN(numero) || numero == undefined) return 0;
      let arrNum = numero.toString().split(".");
      if (arrNum[1] == undefined) arrNum[1] = "";
      let num = arrNum[0];
      if (campo != null) console.log(arrNum[1]);

      if (!isNaN(num)) {
        if (num.length == 4 && num.indexOf("-") == 0) {
          // no se hace nada
        } else {
          num = num
            .split("")
            .reverse()
            .join("")
            .replace(/(?=\d*\.?)(\d{3})/g, "$1.");
          num = num
            .split("")
            .reverse()
            .join("")
            .replace(/^[.]/, "");
        }
        if (decimales > 0) num += ",";
        return num + arrNum[1].padEnd(decimales, "0");
      }
      return "0";
    },
    ...mapMutations(["mostrarLoading", "ocultarLoading"]),
  },
  computed: {
    ...mapState([
      "storage_url",
      "loading",
      "base_url",
      "headers",
      "headers_json",
      "user",
    ]),
    inicio_formated() {
      return this.formatDate(this.inicio);
    },
    termino_formated() {
      return this.formatDate(this.termino);
    },
    partesListBodyFiltered() {
      let filtered = this.partesListBody;
      if (this.filtroFolio) {
        filtered = filtered.filter(item =>
          String(item.folio).includes(this.filtroFolio.trim())
        );
      }
      if (this.filtroGuiaDespacho) {
        filtered = filtered.filter(item =>
          String(item.guia_despacho || '').toLowerCase()
            .includes(this.filtroGuiaDespacho.toLowerCase().trim())
        );
      }
      if (this.filtroWellboat) {
        filtered = filtered.filter(item =>
          String(item.wellboat || '').toLowerCase()
            .includes(String(this.filtroWellboat).toLowerCase().trim())
        );
      }
      if (this.filtroCliente) {
        filtered = filtered.filter(item =>
          String(item.empresa || '').toLowerCase()
            .includes(String(this.filtroCliente).toLowerCase().trim())
        );
      }
      if (this.filtroTipoTrabajo) {
        filtered = filtered.filter(item =>
          String(item.tipo_parte || '').toLowerCase()
            .includes(String(this.filtroTipoTrabajo).toLowerCase().trim())
        );
      }
      return filtered;
    },
    exportableItems() {
      return this.partesListBodyFiltered.filter(item => item.pdf);
    },
    // Fuentes de datos reactivas al store (funciona aunque el fetch llegue tarde)
    wellboats() {
      // Root state: viene de /wellboats/lista/select, ya filtrado mostrar=1 server-side
      return this.$store.state.wellboats || [];
    },
    empresas() {
      return this.$store.getters["empresa/getActive"];
    },
    tipoPartes() {
      return this.$store.getters["tipo_parte/getAll"];
    },
    tipoPartesFiltrados() {
      const excluidos = ['Interno', 'Muestreo'];
      return this.tipoPartes.filter(t => !excluidos.includes(t.nombre));
    },
    allExportSelected: {
      get() {
        return this.exportableItems.length > 0 &&
          this.exportableItems.every(item => this.exportSelectedIds.includes(item.cargas_id));
      },
      set(val) {
        this.exportSelectedIds = val
          ? this.exportableItems.map(item => item.cargas_id)
          : [];
      }
    },
    sortedItems() {
      if (!this.sortColumn) return this.partesListBody

      return [...this.partesListBody].sort((a, b) => {
        const aVal = a[this.sortColumn]
        const bVal = b[this.sortColumn]

        if (typeof aVal === 'string') {
          return this.sortDirection === 'asc'
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal)
        } else {
          return this.sortDirection === 'asc' ? aVal - bVal : bVal - aVal
        }
      })
    }
  },
};
</script>
